import { Subject } from "rxjs";
import { filter } from "rxjs/operators";
import { GriddleThreadedStoreCom } from "./GriddleThreadedStoreCom";
import { GriddleStoreCom } from "./GriddleStoreCom";
// Message types the store will use when passing messages to the StoreFront
export var GridStoreMessageType;
(function (GridStoreMessageType) {
    GridStoreMessageType[GridStoreMessageType["ACTION"] = 0] = "ACTION";
    GridStoreMessageType[GridStoreMessageType["CHANGE"] = 1] = "CHANGE";
})(GridStoreMessageType || (GridStoreMessageType = {}));
var GriddleStoreFront = /** @class */ (function () {
    //private subscriptionsByRef = new WeakMap<object, {unsubscribe: () => void}>();
    function GriddleStoreFront() {
        var _this = this;
        this.gridSubject = new Subject();
        /**
         * Perform actions against the store
         */
        this.executeAction = function (action) {
            return _this.storeCom.sendMessage(action);
        };
        /**
         * Subscribe to changes for a specific grid
         */
        this.subscribe = function (keepAliveRef, gridId, callback) {
            if (!keepAliveRef) {
                throw Error("Must provide a 'keep alive' reference object");
            }
            return _this.gridSubject.pipe(filter(function (change) { return change.gridId === gridId; })).subscribe(callback);
        };
        this.broadcastChange = function (change) {
            _this.gridSubject.next(change.payload);
        };
        this.createStore = function (workerize) {
            if (workerize === void 0) { workerize = false; }
            return workerize ? GriddleThreadedStoreCom.create(_this.broadcastChange) : GriddleStoreCom.create(_this.broadcastChange);
        };
        this.storeCom = this.createStore();
    }
    return GriddleStoreFront;
}());
export { GriddleStoreFront };
//# sourceMappingURL=GriddleStoreFront.js.map